import { useNavigate } from "react-router-dom";
import { Text } from "../../ui-kit/Text/Text";

const getZin = (id, title) => ({ id, title });
const data = [
  getZin(1, "#1/2017  «Красный шахид»"),
  getZin(2, "#2/2018  Литературный журнал «Красный Шекспир»"),
  getZin(3, "#3/2019  «Мёртвый Шекспир»"),
  getZin(4, "Химический завод"),
];

export const Zins = () => {
  const navigate = useNavigate();

  return (
    <div>
      {data.map((item) => (
        <Text
          key={item.id}
          style={{ marginBottom: 40 }}
          active
          extralarge
          onClick={() => navigate(`/zins/${item.id}`)}>
          {item.title}
        </Text>
      ))}

      <Text
        style={{ marginBottom: 40 }}
        active
        extralarge
        onClick={() => navigate(`/zins/eho`)}>
          Эхо Цеха
      </Text>

    </div>
  );
};
